var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"login-page"}},[_c('div',{staticClass:"columns is-gapless"},[_c('div',{staticClass:"column is-5"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"column face_bg is-7"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }